<template>
  <div class="treeBox">
    <el-tree ref="async-router-tree" :default-expanded-keys="[0]" :expand-on-click-node="false" :load="loadNode"
             :props="props"
             lazy node-key="id">
      <span slot-scope="{ node, data }" class="custom-tree-node">
        <span>{{ data.organizationName }}</span>
        <span>
          <template v-if="data.id === 0">
            <Button class="add-root-btn" icon="ios-add" size="small" type="primary"
                    @click="editNode(node, data, 'append')"></Button>
          </template>
          <template v-else>
            <Button icon="ios-add" size="small" type="default" @click="editNode(node, data, 'append')"></Button>
            <Button icon="ios-remove" size="small" type="default" @click="removeNodeConfirmed(node, data)"></Button>
            <Button icon="md-create" size="small" type="default" @click="editNode(node, data, 'edit')"></Button>
          </template>
        </span>
      </span>
    </el-tree>
    <div class="">
      <Button type="default" @click="handleBack('add')">返回</Button>
    </div>
    <div v-if="isNodeEdited" class="modal-mask">
      <Card class="modal-mask-form">
        <p slot="title">
          <Icon size="24" type="ios-create-outline"/>
          <span>新增</span>
        </p>
        <Form ref="asyncRoute" :label-width="200" :model="asyncRoute" :rules="ruleAsyncRoute">
          <FormItem label="类型" prop="organizationType">
            <RadioGroup v-model="asyncRoute.organizationType" class="ml-4">
              <Radio :disabled="organizationType == 2" :label="1" size="large">子公司</Radio>
              <Radio :label="2" size="large">厂站</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="名称" prop="organizationName">
            <Input v-model="asyncRoute.organizationName" placeholder="名称" type="text">
            </Input>
          </FormItem>
          <FormItem v-if="asyncRoute.organizationType == '1'" label="统一社会信用代码" prop="organizationCode">
            <Input v-model="asyncRoute.organizationCode" placeholder="统一社会信用代码" type="text">
            </Input>
          </FormItem>
          <Row justify="center" type="flex">
            <Button :disabled="isSubmitDisabled" type="primary" @click="handleSubmit('asyncRoute')">保存</Button>
            <Button type="default" @click="cancel">取消</Button>
          </Row>
        </Form>
      </Card>
    </div>
    <div v-if="isNodeAdd" class="modal-mask">
      <Card class="modal-mask-form">
        <p slot="title">
          <Icon size="24" type="ios-create-outline"/>
          <span>编辑</span>
        </p>
        <Form ref="asyncRoute" :label-width="200" :model="asyncRoute" :rules="ruleAsyncRoute">
          <FormItem label="类型">
            <RadioGroup v-model="asyncRoute.organizationType" class="ml-4" @change="changeRadio">
              <Radio :label="1" disabled size="large">子公司</Radio>
              <Radio :label="2" disabled size="large">厂站</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="名称" prop="organizationName">
            <Input v-model="asyncRoute.organizationName" placeholder="名称" type="text">
            </Input>
          </FormItem>
          <FormItem v-if="asyncRoute.organizationType == '1'" label="统一社会信用代码" prop="organizationCode">
            <Input v-model="asyncRoute.organizationCode" placeholder="统一社会信用代码" type="text">
            </Input>
          </FormItem>
          <Row justify="center" type="flex">
            <Button :disabled="isSubmitDisabled" type="primary" @click="edithandleSubmit('asyncRoute')">保存</Button>
            <Button type="default" @click="editCancel">取消</Button>
          </Row>
        </Form>
      </Card>
    </div>
  </div>
</template>
<script>
import {companyAdd} from '@/api/organization'

export default {
  name: 'routers',
  inject: ['reload'],
  data() {
    return {
      props: {label: 'organizationName', children: 'children'},
      currentNode: null,
      isSubmitDisabled: false,
      isNodeEdited: false,
      isNodeAdd: false,
      asyncRoute: {
        organizationType: 1
      },
      ruleAsyncRoute: {
        organizationCode: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
        organizationName: [{required: true, message: '请输入名称', trigger: 'blur'}]
      },
      data: []
    }
  },
  // 判断能否拖拽
  created() {
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/organization/organization'
        }
      )
    },
    loadNode(node, resolve) {
      console.log(node)
      if (node.level === 0) {
        // init root of tree
        let root = {
          id: 0,
          organizationId: this.$route.query.organizationId,
          organizationName: this.$route.query.organizationName,
          parentId: null,
        }
        resolve([root])
      } else {
        // init leaves of tree
        this.getNodes(node.data.organizationId).then(value => {
          return resolve(value)
        })
      }
    },
    // 获取数据
    getNodes(parentId) {
      return new Promise((resolve, reject) => {
        this.$http.get('org/auth/organization/list' + '?' + 'parentId=' + parentId).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          this.$Message.error('获取数据失败！')
          reject(error)
        })
      })
    },
    // 新增或者修改
    editNode(node, data, act) {
      this.currentNode = node
      if (act === 'append') {
        this.asyncRoute = {
          parentId: data.organizationId,
          organizationType: data.organizationType || 1
        }
        this.organizationType = data.organizationType
        this.isNodeEdited = true
      } else if (act === 'update') {
        this.asyncRoute = data
        this.isNodeEdited = true
      } else if (act === 'edit') {
        this.asyncRoute = data
        this.isNodeAdd = true
      }
    },
    // 删除提示
    removeNodeConfirmed(node, data) {
      this.$Modal.confirm({
        title: '警告',
        content: '确定删除该组织机构？',
        onOk: () => {
          this.deleteNode(node, data)
        }
      })
    },
    // 确认删除
    deleteNode(node, data) {
      this.$http.delete('org/auth/organization?organizationId=' + data.organizationId).then((res) => {
        if (res.data.code == '00000') {
          this.$Message.success('删除成功！')
          this.remove(node)
        } else {
          this.$Message.error(res.data.msg)
        }
      }).catch(() => {
        this.$Message.error('删除失败！')
      })
    },
    // 删除数据
    remove(node) {
      this.$refs['async-router-tree'].remove(node)
    },
    handleSubmit(name) { // 新增提交
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true
          companyAdd(this.asyncRoute).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.isNodeEdited = false
              this.isSubmitDisabled = false
            } else {
              this.$Message.success(response.data.msg)
              this.reload()
              this.isNodeEdited = false
              this.isSubmitDisabled = false
            }
          }).catch(() => {
            this.isNodeEdited = false
            this.isSubmitDisabled = false
            this.$Message.error('添加失败！')
          })
        }
      })
    },
    // 提交
    edithandleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true
          this.$http.put('org/auth/organization', this.asyncRoute).then(() => {
            this.$Message.success('修改成功')
            this.isNodeAdd = false
            this.isSubmitDisabled = false
          }).catch(() => {
            this.isNodeAdd = false
            this.isSubmitDisabled = false
            this.$Message.error('修改失败')
          })
        }
      })
    },
    // 新增数据
    append(data, node) {
      this.$refs['async-router-tree'].append(data, node)
    },
    // 取消按钮
    cancel() {
      this.isNodeEdited = false
    },
    // 编辑取消按钮
    editCancel() {
      this.isNodeAdd = false
    }
  }
}
</script>

<style lang="less">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .ivu-btn {
    margin-left: 8px;
  }
}

.add-root-btn {
  width: 89px !important;
}

.modal-mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  &-form {
    width: 56%;

    span {
      font-size: 1rem;
    }

    .ivu-btn {
      margin: 0 8px;
    }
  }
}
</style>
